import React, { useMemo } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import type { ChipOwnProps } from '@mui/material/Chip';
import type { SxProps, Theme } from '@mui/material/styles';
import { createSubtleIceSurface, hashStringToSeed } from '../../theme/surfaces';

interface SectionHeadingProps {
  label: React.ReactNode;
  action?: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const SectionHeading: React.FC<SectionHeadingProps> = ({ label, action, sx }) => {
  const frostedGlassCardSx = useMemo(() => createSubtleIceSurface(hashStringToSeed(label?.toString() ?? ''), {}), [label]);

  return (
    <Box
      gap={1}
      sx={{
        ...frostedGlassCardSx,
        p: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        ...sx,
      }}
    >
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        {label}
      </Typography>
      {action}
    </Box>
  );
};
